<template>
  <p class="container">
    {{ text }}
  </p>
</template>

<script lang="ts" setup>
import { computed } from 'vue';
import { TOAST_MESSAGES, ToastAttribute, ToastState } from '@/constants/ToastMessages';

interface Props {
  attribute: ToastAttribute;
  state: ToastState;
}
const props = defineProps<Props>();

const text = computed(() => {
  const target = TOAST_MESSAGES.find((item) => item.attribute === props.attribute);
  return {
    add: target?.addText,
    delete: target?.deleteText,
    systemError: target?.errorText,
  }[props.state];
});
</script>

<style lang="scss" scoped>
.container {
  font-size: 14px;
  padding: 4px 2px;
}
</style>
